module.exports = __webpack_public_path__ + "775842f7d977990067b86feb7d084d9d.png";